import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html'
})
export class BaseComponent {

  @Input()
  public students = [];
  public studentCurrent = 0;
  public currentDate = new Date();
  public courseCurrent;
  public tempIndex = 0;

  constructor() {
  }

  increaseIndex(): void {
    this.studentCurrent++;
    this.tempIndex = this.studentCurrent;
  }

  decreaseIndex(): void {
    this.studentCurrent--;
    this.tempIndex = this.studentCurrent;
  }

  showCourseShedule(course: any): string{
    const obj = {0: '00', 1: '01', 2: '02', 3: '03', 4: '04', 5: '05', 6: '06', 7: '07', 8: '08', 9: '09'};
    const startHour = (course.startTime.hour < 10) ? obj[course.startTime.hour] : course.startTime.hour;
    const startMinute = (course.startTime.minute < 10) ? obj[course.startTime.minute] : course.startTime.minute;
    const endHour = (course.endTime.hour < 10) ? obj[course.endTime.hour] : course.endTime.hour;
    const endMinute = (course.endTime.minute < 10) ? obj[course.endTime.minute] : course.endTime.minute;

    return startHour + ':' + startMinute + ' - ' +  endHour + ':' + endMinute;
  }

  showCourseDays(course: any): string {
    const days: any[] = course.weekDays.map(day => {
      if (day === 'Miercoles') {
        return 'Miércoles';
      } else if (day === 'Sabado') {
        return 'Sábado';
      } else {
        return day;
      }
    });
    return days.join();
  }

  showSerie(serieName: string): string {
    if (serieName) {
      const serieN = Number(serieName);
      const newSerieName = serieN + 1;
      return serieName + '/' + newSerieName % 100;
    }
    return '';
  }

  chooseCourse($event): void {
    console.log($event.target.value);
    this.courseCurrent = this.students[this.studentCurrent].courseInfoArr
    .filter(cour => cour.id === $event.target.value)
    .orElse([{}])[0];
  }
}
